import { handleError } from '@/utils/exception_handler';

import api from './api';

export default {

  // Uses FETCH mutations on APPS
  fetchApps: (context, args = {}) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'fetchApps';

    commit(`${mutationPrefix}Pending`);

    return api.fetchApps(args)
      .then((response) => {
        dispatch('insert', { data: response.entities });

        commit(`${mutationPrefix}Success`, response.entities);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses FETCH mutations on APPS
  fetchSingleApp: (context, args) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'fetchSingleApp';

    commit(`${mutationPrefix}Pending`);

    return api.fetchSingleApp(args)
      .then((response) => {
        dispatch('insert', { data: response.entity });

        commit(`${mutationPrefix}Success`, response.entity);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

};



// WEBPACK FOOTER //
// ./src/store/modules/app/actions.js